import classNames from 'classnames';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverrideBool } from '../../../utilities/utils';
import BookableItem from '../BookableItem/BookableItem';
import Slider from '../Slider/Slider';
import toggleExtraLife from '../../../utilities/specialFeatures';
import { addCustomTagEvent } from '../../../utilities/customTag';

import './ItemSelection.css';

const _ = require('lodash')

// Props
// landscape: boolean;
// isToggle: boolean;

let timeslotClicked = false;
let imageWidth_temp = "";
let imageHeight_temp = "";

const mapStateToProps = (state) => {
  return {
    languageObj: state.language.sub_components.item_selection_js,
  };
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(class ItemSelection extends Component {
  // autoInterval: number;
  // carouselRef: HTMLElement | null;
  // timeslotsRef: HTMLElement | null;

  constructor(props) {
    super(props);
    this.itemCategoryId = props.itemCategoryId;

    const sortedTimeslots = Object.keys(props.timeslots).map((timeslotId, index) => {
      return props.timeslots[timeslotId];
    }).sort((a, b) => {
      if (a === undefined) return 1;
      else if (b === undefined) return -1;
      else return a.moment.valueOf() - b.moment.valueOf();
    });

    let defaultTimeslot = -1;
    if (sortedTimeslots) {
      if (sortedTimeslots.length === 1) defaultTimeslot = sortedTimeslots[0].timeslotId;
      else {
        for (let i = 0; i < sortedTimeslots.length; i++) {
          if (this.getItemsSelected(sortedTimeslots[i].timeslotId.toString()) > 0) {
            defaultTimeslot = sortedTimeslots[i].timeslotId;
            break;
          }
        }
      }
    }

    this.updateBackgroundSize();

    this.state = {
      selectedTimeslotId: defaultTimeslot,

      imageWidth: imageWidth_temp,
      imageHeight: imageHeight_temp,
    };
  }

  componentWillMount() {
    timeslotClicked = false;
    //if there's only one party slot, it will automatically open selection, so transform background
    if (Number(this.props.itemCategoryId) === 2 && Object.keys(this.props.timeslots).length === 1) {
      timeslotClicked = true;
    } else if (toggleExtraLife() && Object.keys(this.props.timeslots).length === 1) {
      timeslotClicked = true;
    }
    this.updateBackgroundSize();
    window.addEventListener('resize', this.updateBackgroundSize);
    if (Number(this.props.itemCategoryId) === 2) {
      if (Object.keys(this.props.timeslots).length > 1) {
        this.resetBackground();
      } else {
        // this.updateBackgroundSize();
        this.updateBackgroundSize();
      }
    } else {
      this.updateBackgroundSize();
    }
  }

  componentDidMount() {
    this.updateBackgroundSize();
  }

  componentWillUnmount() {

  }

  resetBackground = () => {

  }

  updateBackgroundSizeParty = () => {
    let image_width = 0, image_height = 0;
    //update initial render size of background (special case)
    if (window.innerWidth >= 720) {
      image_width = Math.min(window.innerWidth - 20, 1150);
      image_height = image_width * 9 / 14;
      if (image_height > window.innerHeight - 310.625) {
        image_height = window.innerHeight - 310.625;
        image_width = image_height * 14 / 9;
      }

    } else {
      image_width = Math.min(window.innerWidth - 60, 400);
      image_height = image_width * 14 / 9;

      //consider if in landscape mode
      if (this.props.landscape || (window.innerWidth > window.innerHeight)) {
        image_width = window.innerWidth - 80;
        image_height = image_width * 9 / 14;
        //if height is too much
        if (image_height > window.innerHeight - 60 - 69 - 5) {
          image_height = window.innerHeight - 60 - 69 - 5;
          image_width = image_height * 14 / 9;
        }
      }
      else if (image_height > window.innerHeight - 60 - 38 - 31) {
        image_height = window.innerHeight - 60 - 38 - 31;
        image_width = image_height * 9 / 14;
      }
    }

    imageWidth_temp = String(image_width);
    imageHeight_temp = String(image_height)

  }

  updateBackgroundSize = () => {
    let image_width = 0, image_height = 0;

    if (window.innerWidth >= 720) {
      image_width = Math.min(window.innerWidth - 10, 1150);
      image_height = image_width * 9 / 14;

      //first consider case where bookable component is present with ad, or items list is populated, or its a party room page
      if ((timeslotClicked || !_.isEmpty(this.props.selectedItems || Object.keys(this.props.timeslots).length === 1)) && window.innerWidth < 1350) {
        if (window.innerWidth <= 1000) {
          image_width = window.innerWidth - 340;
          image_height = image_width * 14 / 9;
          //if image is larger than screen height
          if (image_height > window.innerHeight - 95 - 60 - 60 - 75) {
            //adjust the image width depending on height
            image_height = window.innerHeight - 95 - 60 - 60 - 75 - 20;
            image_width = image_height * 9 / 14;
          }
        } else {
          image_width = window.innerWidth - 340;
          image_height = image_width * 9 / 14;
        }

      }
      else if (image_height > window.innerHeight - 310.625) {
        image_height = window.innerHeight - 310.625;
        image_width = image_height * 14 / 9;
      }

    } else {
      image_width = Math.min(window.innerWidth - 60, 400);
      image_height = image_width * 14 / 9;

      //consider if in landscape mode
      if (this.props.landscape || (window.innerWidth > window.innerHeight)) {
        image_width = window.innerWidth - 80;
        image_height = image_width * 9 / 14;
        //if height is too much
        if (image_height > window.innerHeight - 60 - 69 - 5) {
          image_height = window.innerHeight - 60 - 69 - 5;
          image_width = image_height * 14 / 9;
        }
      }
      else if (image_height > window.innerHeight - 60 - 38 - 31) {
        image_height = window.innerHeight - 60 - 38 - 31;
        image_width = image_height * 9 / 14;
      }

    }


    this.setState({
      imageWidth: String(image_width),
      imageHeight: String(image_height)
    })

  }

  getItemsSelected(timeslotId) {
    const timeslot = this.props.timeslots[timeslotId];
    const selectedItems = this.props.selectedItems[timeslotId];
    let totalItemsInUse = 0;
    if (timeslot !== undefined && selectedItems !== undefined) {
      timeslot.itemIds.forEach((itemId) => {
        const itemQuantity = selectedItems[itemId];
        if (itemQuantity !== undefined) totalItemsInUse += itemQuantity;
      });
    }
    return totalItemsInUse;
  }

  onClickTimeslot(id) {
    this.setState({
      selectedTimeslotId: id,
    });
    //update global variable
    timeslotClicked = true;

    this.updateBackgroundSize();
  }

  onClickPlus = (itemId) => {
    const timeslotId = this.state.selectedTimeslotId;
    const selectedItems = this.props.selectedItems[timeslotId];
    const quantity = selectedItems ? selectedItems[itemId] || 0 : 0;
    if (quantity !== undefined) {
      const newQuantity = quantity + 1;
      if (this.validateQuantity(timeslotId, itemId, newQuantity)) {
        this.updateItemQuantity(timeslotId, itemId, newQuantity);
      }
      addCustomTagEvent({
        event: 'AddToCart',
        category: 'Cart',
        label: 'Item Select',
        checkoutDetails: {
          onClick: 'onClickPlus',
          item: itemId,
          itemCategory: this.props.itemCategoryId,
          quantity: newQuantity
        }
      });
    }
  }

  onClickMinus = (itemId) => {
    const timeslotId = this.state.selectedTimeslotId;
    const selectedItems = this.props.selectedItems[timeslotId];
    const quantity = selectedItems ? selectedItems[itemId] || 0 : 0;
    if (quantity !== undefined) {
      const newQuantity = quantity - 1;
      if (this.validateQuantity(timeslotId, itemId, newQuantity)) {
        this.updateItemQuantity(timeslotId, itemId, newQuantity);
      }
      addCustomTagEvent({
        event: 'AddToCart',
        category: 'Cart',
        label: 'Item Select',
        checkoutDetails: {
          onClick: 'onClickMinus',
          item: itemId,
          itemCategory: this.props.itemCategoryId,
          quantity: newQuantity
        }
      });
    }
  }

  onChangeQuantity = (itemId, newQuantity) => {
    const timeslotId = this.state.selectedTimeslotId;
    if (this.validateQuantity(timeslotId, itemId, newQuantity)) {
      this.updateItemQuantity(timeslotId, itemId, newQuantity);
    }
    addCustomTagEvent({
      event: 'AddToCart',
      category: 'Cart',
      label: 'Item Select',
      checkoutDetails: {
        onClick: 'onChange',
        item: itemId,
        itemCategory: this.props.itemCategoryId,
        quantity: newQuantity
      }
    });
  }

  onClickItem = (itemId) => {
    const timeslotId = this.state.selectedTimeslotId;
    const selectedItems = this.props.selectedItems[timeslotId];
    const quantity = selectedItems ? selectedItems[itemId] || 0 : 0;
    if (quantity !== undefined) {
      const newQuantity = 1 - quantity;
      if (this.validateQuantity(timeslotId, itemId, newQuantity)) {
        this.updateItemQuantity(timeslotId, itemId, newQuantity);
      }
      addCustomTagEvent({
        event: 'AddToCart',
        category: 'Cart',
        label: 'Item Select',
        checkoutDetails: {
          onClick: 'onClick',
          item: itemId,
          itemCategory: this.props.itemCategoryId,
          quantity: newQuantity
        }
      });
    }

  }

  updateItemQuantity(timeslotId, itemId, quantity) {
    this.props.updateItemQuantity(timeslotId, itemId, quantity);

    // propagate the sub changes down if canTimeSplit is true.
    let items = this.props.items[itemId];
    if (items && items.stationExtra && items.stationExtra.length !== 0) {
      this.updateSubQuantity(timeslotId, itemId, quantity);
    }
  }

  validateQuantity = (timeslotId, itemId, quantity) => {
    const override = this.props.validateQuantity(timeslotId, itemId, quantity);
    if (override === OverrideBool.False) {
      return false;
    }

    const timeslot = this.props.timeslots[timeslotId];
    const selectedItems = this.props.selectedItems[timeslotId];
    if (timeslot !== undefined) {
      const oldQuantity = selectedItems ? selectedItems[itemId] || 0 : 0;
      if (oldQuantity !== undefined) {
        let availableItems = 0;
        let usedItems = 0;

        if (this.props.isLocalQuantity) {
          availableItems = timeslot.itemAvailable[itemId] || 0;
          usedItems = oldQuantity;
        }
        else {
          availableItems = timeslot.availableItems;
          timeslot.itemIds.forEach((itemIdKey) => {
            usedItems += selectedItems ? selectedItems[itemIdKey] || 0 : 0;
          });
        }
        let newTotal = (quantity - oldQuantity) + usedItems;
        if (newTotal >= 0 && newTotal <= availableItems && availableItems > 0 && quantity >= 0) {
          return true;
        }
        return false;
      }
    }
    return false;
  }

  // This section is for sub/extra field
  onClickSubPlus = (itemId) => {
    const timeslotId = this.state.selectedTimeslotId;
    if (this.props.selectedExtra) {
      const selectedExtra = this.props.selectedExtra[timeslotId];
      const quantity = selectedExtra ? selectedExtra[itemId] || 0 : 0;
      if (quantity !== undefined) {
        const newQuantity = quantity + 1;
        if (this.validateSubQuantity(timeslotId, itemId, newQuantity)) {
          this.updateSubQuantity(timeslotId, itemId, newQuantity);
        }
        addCustomTagEvent({
          event: 'AddToCart',
          category: 'Cart',
          label: 'Item Select',
          checkoutDetails: {
            onClick: 'onClickSubPlus',
            item: itemId,
            itemCategory: this.props.itemCategoryId,
            extraQuantity: newQuantity
          }
        });
      }
    }
  }

  onClickSubMinus = (itemId) => {
    const timeslotId = this.state.selectedTimeslotId;
    if (this.props.selectedExtra) {
      const selectedExtra = this.props.selectedExtra[timeslotId];
      const quantity = selectedExtra ? selectedExtra[itemId] || 0 : 0;
      if (quantity !== undefined) {
        const newQuantity = quantity - 1;
        if (this.validateSubQuantity(timeslotId, itemId, newQuantity)) {
          this.updateSubQuantity(timeslotId, itemId, newQuantity);
        }
        addCustomTagEvent({
          event: 'AddToCart',
          category: 'Cart',
          label: 'Item Select',
          checkoutDetails: {
            onClick: 'onClickSubMinus',
            item: itemId,
            itemCategory: this.props.itemCategoryId,
            extraQuantity: newQuantity
          }
        });
      }
    }
  }

  onChangeSubQuantity = (itemId, newQuantity) => {
    const timeslotId = this.state.selectedTimeslotId;
    if (this.validateSubQuantity(timeslotId, itemId, newQuantity)) {
      this.updateSubQuantity(timeslotId, itemId, newQuantity);
    }
    addCustomTagEvent({
      event: 'AddToCart',
      category: 'Cart',
      label: 'Item Select',
      checkoutDetails: {
        onClick: 'onChange',
        item: itemId,
        itemCategory: this.props.itemCategoryId,
        extraQuantity: newQuantity
      }
    });
  }

  validateSubQuantity = (timeslotId, itemId, quantity) => {
    const timeslot = this.props.timeslots[timeslotId];
    const selectedItems = this.props.selectedItems[timeslotId];
    if (timeslot !== undefined) {
      const itemQuantity = selectedItems ? selectedItems[itemId] || 0 : 0;
      if (itemQuantity !== undefined) {
        if (quantity >= itemQuantity && quantity <= itemQuantity * 2) {
          return true;
        }
        return false;
      }
    }

    return false;
  }

  updateSubQuantity(timeslotId, itemId, quantity) {
    this.props.updateSubQuantity && this.props.updateSubQuantity(timeslotId, itemId, quantity);
  }
  // End of Sub / Extra field

  render() {
    const timeslots = this.props.timeslots;
    const selectedTimeslot = timeslots[this.state.selectedTimeslotId];

    let backgroundStyle = (toggleExtraLife()) ? {
      "backgroundSize": `${this.state.imageWidth}px ${this.state.imageHeight}px`,
    } : {};
    let hideBackgroundStyle = (toggleExtraLife()) ? "" : "ItemSelection-no-background";
    let conditionalWhiteText = (toggleExtraLife()) ? "ItemSelection-white-text" : "";
    let hidePulse = (toggleExtraLife()) ? {
      "display": "none"
    } : {};
    let conditionalBackground = "";

    //if a timeslot has been clicked, need to switch image and resize it.... or only one item existent because menu will automatically be up
    if (window.innerWidth < 1650 && (timeslotClicked || !_.isEmpty(this.props.selectedItems) || Object.keys(this.props.timeslots).length === 1)) {
      if (window.innerWidth > 1000) {
        //just move horizontal image to the right
        //find the number of PIXELS to slide image to the right...
        backgroundStyle = (toggleExtraLife()) ? {
          "backgroundSize": `${this.state.imageWidth}px ${this.state.imageHeight}px`,
          "backgroundPosition": `330px ${215+5}px`,
        } : {};
      } else if (window.innerWidth > 720 && !this.props.landscape) {
        //switch to vertical image and handle moving that
        conditionalBackground = "ItemSelection-conditional";
        let xPos = (window.innerWidth - 50) / 2;

        backgroundStyle = (toggleExtraLife()) ? {
          "backgroundSize": `${this.state.imageWidth}px ${this.state.imageHeight}px`,
          "backgroundPosition": `${xPos}px ${215+5}px`,
        } : {};
      } else if (window.innerWidth > 600 && this.props.landscape) {
        let xPos = (window.innerWidth - 50) / 2.1;
        xPos = Math.max(330, xPos);
        //simple condition to estimate whether its a landscape mobile device or not
        //test if it is NOT a mobile device landscape (switch to vertical image then)
        if (window.innerWidth / window.innerHeight <= 1.6 || (this.state.imageHeight > this.state.imageWidth)) {
          conditionalBackground = "ItemSelection-conditional";
        }

        backgroundStyle = (toggleExtraLife()) ? {
          "backgroundSize": `${this.state.imageWidth}px ${this.state.imageHeight}px`,
          "backgroundPosition": `${xPos}px ${215+5}px`,
        } : {};
      }
    }


    const sortedTimeslots = Object.keys(timeslots).map((timeslotId, index) => {
      return timeslots[timeslotId];
    }).sort((a, b) => {
      if (a === undefined) return 1;
      else if (b === undefined) return -1;
      else return a.moment.valueOf() - b.moment.valueOf();
    });

    if (sortedTimeslots.length > 0) {
      return (
        <div className={'ItemSelection ' + conditionalBackground + ' ' + conditionalWhiteText + ' ' + hideBackgroundStyle} style={backgroundStyle}>
          <div className={'ItemSelection-timeslots'}>
            <Slider scrollTickInterval={40} horizontal={this.props.landscape}>
              {sortedTimeslots.map((timeslot, index) => {
                if (timeslot !== undefined) {
                  const disabled = timeslot.utc_moment.valueOf() <= moment().valueOf();

                  const formattedTime = timeslot.moment.format('h:mm a').toLocaleUpperCase();
                  const itemsSelected = this.getItemsSelected(timeslot.timeslotId.toString());
                  const numRemaining = timeslot.availableItems - itemsSelected;
                  const timeslotClasses = classNames('ItemSelection-timeslot', {
                    'ItemSelection-timeslot--selected': this.state.selectedTimeslotId !== -1 && timeslot.timeslotId === this.state.selectedTimeslotId,
                    'ItemSelection-timeslot--disabled': timeslot.availableItems === 0 || disabled
                  });
                  const timeslotTimeClasses = classNames('ItemSelection-timeslot-time', {
                    'ItemSelection-timeslot-time--selected': itemsSelected > 0
                  });
                  const availabilityClasses = classNames('ItemSelection-timeslot-availability', {
                    'ItemSelection-timeslot-availability--selected': itemsSelected > 0,
                    'ItemSelection-timeslot-availability--lowquantity': !this.props.isToggle && timeslot.availableItems <= 4,
                    'ItemSelection-timeslot-availability--noavailable': timeslot.availableItems === 0,
                    'ItemSelection-timeslot-availability--passed': disabled
                  });
                  return (
                    <div
                      className={timeslotClasses}
                      key={index}
                      onClick={disabled || timeslot.availableItems === 0 ? () => { return false; } :
                        this.onClickTimeslot.bind(this, timeslot.timeslotId)}
                    >
                      <div className={'ItemSelection-timeslot-flex'}>
                        <div className={timeslotTimeClasses}>
                          {formattedTime}
                        </div>
                        <div className={availabilityClasses}>
                          {disabled ? this.props.languageObj.render.passed : numRemaining > 0 ? numRemaining + this.props.languageObj.render.left : this.props.languageObj.render.sold_out}
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </Slider>
          </div>
          {/* <div className={'ItemSelection-spacer'}>{}</div> */}
          <div className={'ItemSelection-items ' + hideBackgroundStyle} style={backgroundStyle}>
            {selectedTimeslot ? selectedTimeslot.itemIds.map((itemId, index) => {
              const item = this.props.items[itemId];
              const selectedItems = this.props.selectedItems[selectedTimeslot.timeslotId];
              const selectedExtra = this.props.selectedExtra ? this.props.selectedExtra[selectedTimeslot.timeslotId] : {};
              const itemsSelected = this.getItemsSelected(selectedTimeslot.timeslotId.toString());
              const numRemaining = selectedTimeslot.availableItems - itemsSelected;
              if (item !== undefined) {
                const itemQuantity = selectedItems ? selectedItems[itemId] || 0 : 0;
                const extraQuantity = selectedExtra ? selectedExtra[itemId] || 0 : 0;
                if (itemQuantity !== undefined) {
                  let plusMoreValid = true;
                  const tssi = this.props.timeslots[this.state.selectedTimeslotId];
                  if (tssi !== undefined) {
                    plusMoreValid = tssi.utc_moment.valueOf() >= moment().valueOf();
                  }
                  const minusValid = this.validateQuantity(this.state.selectedTimeslotId, itemId, itemQuantity - 1);
                  const plusValid = plusMoreValid && this.validateQuantity(this.state.selectedTimeslotId, itemId, itemQuantity + 1);
                  const subMinusValid = this.validateSubQuantity(this.state.selectedTimeslotId, itemId, extraQuantity - 1);
                  const subPlusValid = this.validateSubQuantity(this.state.selectedTimeslotId, itemId, extraQuantity + 1);
                  return (
                      <BookableItem
                        key={selectedTimeslot.timeslotId - index * 5}   //  Haha, try and figure out what this does!
                        title={item.title}
                        description={item.description}
                        disabledDescription={item.disabledDescription}
                        helpText={item.helpText}
                        singleton={false}
                        disabled={this.validateQuantity(this.state.selectedTimeslotId, itemId, itemQuantity || 0) === false}
                        quantity={itemQuantity}
                        subQuantity={extraQuantity || 0}
                        selected={itemQuantity >= 1}
                        numRemaining={numRemaining}
                        minusDisabled={minusValid === false}
                        plusDisabled={plusValid === false}
                        handleClickMinus={this.onClickMinus.bind(this, itemId)}
                        handleClickPlus={this.onClickPlus.bind(this, itemId)}
                        handleChangeQuantity={this.onChangeQuantity.bind(this, itemId)}
                        handleClickItem={() => {/**/ }}
                        landscape={this.props.landscape}
                        isStation={item.isStation}
                        canTimeSplit={!(item.stationExtra === undefined || item.stationExtra.length === 0 || selectedTimeslot.addonIds === undefined || selectedTimeslot.addonIds.length === 0)}
                        handleClickSubPlus={this.onClickSubPlus.bind(this, itemId)}
                        handleClickSubMinus={this.onClickSubMinus.bind(this, itemId)}
                        handleChangeSubQuantity={this.onChangeSubQuantity.bind(this, itemId)}
                        subMinusDisabled={subMinusValid === false}
                        subPlusDisabled={subPlusValid === false}
                      />
                    );
                }
              }
              return null;
            }) :
              <div className={'ItemSelection-items-pulse'} style={hidePulse}>
                {this.props.languageObj.render.item_selection_pulse}
              </div>
            }
            {selectedTimeslot && selectedTimeslot.itemIds.length === 0 && (
              <div className={'ItemSelection-items-emptyItem ' + hideBackgroundStyle}>
                {this.props.languageObj.render.item_selection_empty_item}
              </div>
            )}
          </div>
          {/* <div className={'ItemSelection-bigtime'}>
            <h1>
              {selectedTimeslot.moment.format('h:mm').toLocaleUpperCase()}
            </h1>
          </div> */}
        </div>
      );
    }
    else {
      return (
        <div className={'ItemSelection ' + hideBackgroundStyle + ' ' + conditionalBackground} style={backgroundStyle}>
          <div className={'ItemSelection-empty ' + hideBackgroundStyle } style={backgroundStyle}>
            <div className={'ItemSelection-empty-content'}>
              {this.props.noItemsMessage || this.props.languageObj.render.item_selection_empty_content}
            </div>
          </div>
        </div>
      );
    }
  }
})
